import { useTranslation } from "react-i18next";
import { PaymentMethod } from "../../../../redux/apiSpecifications/apiSubjects";
import { FormRow } from "../../../../style/form";
import SelectPaymentType from "../../../Inputs/SelectPaymentType";
import { RowSpacer } from "../../../../style/containers";
import { InputTextStyled } from "../../../../style/Input";
import styled from "styled-components";
import { isNotEmpty } from "../../../../validation/common";
import { useEffect, useMemo } from "react";
import useFormData from "../../../../hooks/useFormData";
import FormModal from "../../../Modals/FormModal";

interface ISubjectPaymentMethodFormProps {
  subjectPaymentMethod: PaymentMethod;
  disableForm?: boolean;
  onChange?: (value: any, field: string) => void;
}

const SubjectPaymentMethodForm = ({
  subjectPaymentMethod,
  disableForm,
  onChange,
}: ISubjectPaymentMethodFormProps) => {
  const { t } = useTranslation();

  const handleOnChange = (value: any, field: string) => {
    if (onChange) onChange(value, field);
  };

  return (
    <>
      <FormRow>
        <SelectPaymentType
          value={subjectPaymentMethod.type}
          onChange={(type) => handleOnChange(type, "type")}
        />

        <RowSpacer />

        <InputTextStyled
          label={t("subject-payment-iban-label")}
          value={subjectPaymentMethod.iban}
          tooltip={t("subject-payment-iban-tooltip")}
          onChange={(iban) => handleOnChange(iban, "iban")}
        />
      </FormRow>
    </>
  );
};

export default SubjectPaymentMethodForm;

interface ISubjectPaymentMethodModalProps {
  open: boolean;
  subjectPaymentMethod?: PaymentMethod;
  onCancel: () => void;
  onConfirm: (subjectPaymentMethod: PaymentMethod) => void;
}

export const SubjectPaymentMethodModal = ({
  open,
  subjectPaymentMethod,
  onCancel,
  onConfirm,
}: ISubjectPaymentMethodModalProps) => {
  const { t } = useTranslation();

  const {
    formData: _subjectPaymentMethod,
    setFormData: setSubjectPaymentMethod,
    onChangeFormData: onChangeSubjectPaymentMethod,
  } = useFormData<PaymentMethod>();

  useEffect(() => {
    if (open) {
      setSubjectPaymentMethod(subjectPaymentMethod);
    }
  }, [open]);

  const handleOnConfirmSubjectPaymentMethod = () => {
    onConfirm({ ..._subjectPaymentMethod! });
  };

  const isSubjectPaymentValid = useMemo(() => {
    return (
      isNotEmpty(_subjectPaymentMethod?.type) &&
      isNotEmpty(_subjectPaymentMethod?.iban)
    );
  }, [_subjectPaymentMethod]);

  return (
    <FormModal
      open={open}
      isConfirmButtonDisabled={!isSubjectPaymentValid}
      onCancel={onCancel}
      onConfirm={handleOnConfirmSubjectPaymentMethod}
    >
      {_subjectPaymentMethod && (
        <SubjectPaymentMethodForm
          subjectPaymentMethod={_subjectPaymentMethod}
          onChange={onChangeSubjectPaymentMethod}
        />
      )}
    </FormModal>
  );
};
